import script from "./action-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./action-editor.vue?vue&type=script&setup=true&lang=js"

import "./action-editor.vue?vue&type=style&index=0&id=fd68b74a&lang=scss"

const __exports__ = script;

export default __exports__